export type PaymentPlan = typeof PAYMENT_PLANS[number]

export const PAYMENT_PLANS = [
  {
    name: 'Monthly',
    discount: 0,
    periodUnit: 'month',
    selected: true,
    monthQty: 1,
    periodLabel: 'monthly',
  },
  {
    name: 'Quarterly',
    discount: 10,
    periodUnit: 'quarter',
    monthQty: 3,
    periodLabel: 'quarterly',
  },
  {
    name: 'Annual',
    discount: 15,
    periodUnit: 'year',
    monthQty: 12,
    periodLabel: 'annually',
  }
] as const
